import languages from './data/languages/languages'
import directionality from './data/languages/directionality'
import {getFormatLocaleForLanguage} from './data/languages/formattingLocales'
import { formatLocale } from 'd3-format'

const languageOverrides = {
  pt: {
    cases: 'casos',
    Cases: 'Casos',
  },
  fr:  {
    cases: 'cas',
    Cases: 'Cas',
    fatalities: 'décès',
    Fatalities: 'Décès',
    covid19CaseMapperWorld: 'Cartographie de cas global COVID-19',
  }
}

export const languageLocalStorageKey = 'covid19WorldLanguage'
const languagesByCode = {}

languages.forEach(language => languagesByCode[language.code] = language.name)

const texts = {}
const textsRequested = {}

export function getDirectionality(languageCode) {
  return directionality[languageCode] || 'ltr'
}

export function getDefaultLanguage() {
  let defaultLanguage = null
  let storedLanguage = window.localStorage.getItem(languageLocalStorageKey)
  if (languagesByCode[storedLanguage]) {
    defaultLanguage = storedLanguage
  }
  // once a user selects a language that should be put in local storage and we an query that first, but for now
  navigator.languages.forEach(userLanguage => {
    if (defaultLanguage) return
    if (languagesByCode[userLanguage]) {
      defaultLanguage = userLanguage
    }
  })

  if (!defaultLanguage) {
    // if we still haven't found a language, try again but only consider parts of the language codes..
    navigator.languages.forEach(userLanguage => {
      if (defaultLanguage) return
      if (userLanguage.matches) {
        const isExtendedLanguageCode = userLanguage.matches(/([a-z]{2})-[a-z]{2}/i)
        if (isExtendedLanguageCode) {
          const codeToTry = isExtendedLanguageCode[1]
          if (languagesByCode[codeToTry]) {
            defaultLanguage = codeToTry
          }
        }
      }
    })
  }

  if (!defaultLanguage) {
    // default to English if nothing can be determined.
    defaultLanguage = 'en'
  }
  return defaultLanguage
}

export function loadLocaleFile(language) {
  if (!textsRequested[language]) {
    textsRequested[language] = new Promise((resolve) => {
      import(`./data/languages/${language}.json`).then(langaugeFile => {
        texts[language] = langaugeFile.default

        resolve()
      })
    })
  }

  return textsRequested[language]
}

const missingTextKeys = {}

export function getText(language, key) {
  if (!language || !key) {
    console.log('getText called without a language or key', language, key)
    // debugger
    return ''
  }
  if (!textsRequested[language]) {
    loadLocaleFile(language)
  }
  if (languageOverrides[language] && languageOverrides[language][key]) {
    return languageOverrides[language][key];
  }

  if (!texts[language]) {
    // console.log('language promise requested but not resolved')
  } else if (!texts[language][key]) {
    const printOnceKey = `${language}---${key}`
    if (!missingTextKeys[printOnceKey]) {
      missingTextKeys[printOnceKey] = true
      console.log(language, 'doesn\'t have text key', key)
    }
    return `*${key}`
  } else {
    return texts[language][key]
  }
  return ''
}

export function getD3Formatter(language) {
  return formatLocale(getFormatLocaleForLanguage(language)).format
}

export default languages
